module.exports = __webpack_public_path__ + "hand-press-icon.png?b60a3c62a3346d100244988198890be0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hand-press-icon.png
// module id = 21
// module chunks = 0